// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
import { useState, useEffect } from 'react'
import {
  GuidedTourPlugin,
  GuidedTourStep
} from '@storage/react-guided-tour-plugin'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { GuidedWorkspaceData } from '../GuidedWorkspaceData'
import { isV2 } from '../../../utils/feature-flag-utils'

const GuidedTour = ({ tourName, setIsGuidedModalOpen, pathname, size }) => {
  const { t } = useTranslation(['dashboard'])
  const stopGuidedTour = () => {
    sessionStorage.removeItem('glcpGuidedWorkspace')
    setIsGuidedModalOpen(false)
  }

  const defaultData = GuidedWorkspaceData()
  const [data, setData] = useState(defaultData)
  const [loaded, setLoaded] = useState(false)

  const handleAlign = ({ cardData }) => {
    let align
    switch (pathname) {
      case '/manage-account/identity/users':
        align =
          isV2() || ['large', 'xlarge', 'medium'].includes(size)
            ? 'bottomRight'
            : 'bottomLeft'
        break
      case '/services/service-catalog':
        align = ['xlarge'].includes(size) ? 'right' : 'bottomCenter'
        break
      case '/services/service-subscriptions':
        align = ['xlarge', 'large'].includes(size) ? 'left' : 'topCenter'
        break
      case '/devices/subscriptions-list':
        align = ['xlarge', 'large'].includes(size) ? 'left' : 'topCenter'
        break
      case '/devices/inventory-list':
        align = ['xlarge', 'large'].includes(size) ? 'left' : 'topCenter'
        break
      default:
        return cardData
    }
    return { ...cardData, align }
  }
  useEffect(() => {
    setLoaded(false)
    setData((prevData) => {
      const newData = { ...prevData }
      if (newData[pathname]) {
        newData[pathname] = newData[pathname].map((cardData) => {
          return handleAlign({ cardData })
        })
      }
      setLoaded(true)
      return newData
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [size])
  return (
    <>
      {loaded && (
        <GuidedTourPlugin
          dataTestId={tourName}
          tourName={tourName}
          finishBtnLabel={t('dashboard:guided_workspace.close_btn')}
          onTourSkip={() => stopGuidedTour()}
          onTourFinish={() => {
            stopGuidedTour()
          }}
          steps={data[pathname]}
        >
          {data[pathname]?.map((item) => (
            <GuidedTourStep
              dataTestId="guided-content"
              slot={item?.slot}
              align="start"
            >
              {item?.content}
            </GuidedTourStep>
          ))}
        </GuidedTourPlugin>
      )}
    </>
  )
}

GuidedTour.propTypes = {
  tourName: PropTypes.string.isRequired,
  setIsGuidedModalOpen: PropTypes.func.isRequired,
  pathname: PropTypes.string.isRequired,
  size: PropTypes.string.isRequired
}
export default GuidedTour
